import {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../../../../_ovlclient/src/library/table/tableapi"

export type AdminColumnsType = {
  CardCode?: string
  OfferType?: "Target" | "Actual"
  CntctCode?: number
  FileType?: "bvx" | "3d"
  U_PrtOfferingCadAttr?: string
  PrtOfferingCadUserField?: string
  U_PrtOfferingCadVal?: string
  File?: any
}

let AdminUploadColumns: {
  [key in keyof AdminColumnsType]: SYSColumnDef
} = {
  CardCode: { ui: { fillSpaceIfNotVisible: false } },
  OfferType: {
    list: {
      displayField: "OfferTypeName",
      valueField: "OfferType",
      mode: "Option",
    },
    ui: {
      option: { inline: true },
      labelTranslationKey: "QUTOfferingColOfferingAdminOfferType",
    },
  },
  CntctCode: {
    type: "text",
    list: {
      displayField: "CntctName",
      valueField: "CntctCode",
      displayValueField: false,
      mode: "List",
      serverEndpoint: "offering/bp_contacts",
      onlyRefreshFromServerIfOlderThanMs: 10000,
      tryGetLookupFromServerInFormInitIfNotFound: true,
    },
    ui: {
      labelTranslationKey: "QUTOfferingColOfferingCntctName",
    },
  },
  FileType: {
    type: "text",
    list: {
      displayField: "FileType",
      valueField: "FileType",
      mode: "Option",
    },
    ui: {
      option: { inline: true },
      labelTranslationKey: "QUTOfferingOfferingAdminFileType",
    },
  },

  U_PrtOfferingCadAttr: {
    ui: { labelTranslationKey: "QUTOfferingOfferingCadAttr" },
    list: {
      displayField: "CadAttr",
      valueField: "CadAttr",
    },
  },
  PrtOfferingCadUserField: {
    type: "int",
    ui: {
      labelTranslationKey: "QUTOfferingOfferingCadUserField",
    },
  },
  U_PrtOfferingCadVal: {
    ui: { labelTranslationKey: "QUTOfferingOfferingCadVal" },
  },
  File: {
    type: "asset",
  },
}

export let tblAdminUpload: SYSTableDef = {
  id: "QUTOfferingAdminUpload",

  database: { dataIdField: "CardCode" },
  features: {
    add: true,
    edit: true,
    focusToFirstEditableField: true,
  },
  title: { dialogTitle: { translationKey: "QUTOfferingMenuOffering" } },
  columns: AdminUploadColumns,
}
